import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, } from 'reactstrap';
import { Link } from 'react-router-dom';
import './Shared/Css/NavMenu.css';
import WatchMenu from './WatchApi/WatchMenu';
import jungjinlog from './img/coup/220130_JungJin_logo-01.png';
import jcouplog from './img/coup/220130_Jcoup_logo-03.png';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    return (
      <header>
        {/* <Navbar className="navbar-expand-sm navbar-toggleable-sm bg-light border-bottom box-shadow mb-2" light > */}
        <Navbar
          className="navbar-expand-sm navbar-toggleable-sm bg-light border-bottom box-shadow mb-2"
          fixed="top"
          light
        >
          <Container fluid>
            <NavbarBrand href="https://jcoup.co.kr/">
              <img src={jungjinlog} width={30} height={30} alt="" />
              메인홈
            </NavbarBrand>
            <NavLink tag={Link} style={{ fontSize: 16 }} to="/">
              <img src={jcouplog} width={30} height={30} alt="" />
              서브홈
            </NavLink>
            <NavbarBrand
              href="http://www.jcoup.co.kr/NoteInquiry"
              style={{ fontSize: 15, color: 'blueviolet' }}
            >
              <i
                className="fa-regular fa-envelope"
                style={{ fontSize: 22 }}
              ></i>
              피막[접착]문의하기
            </NavbarBrand>

            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse
              className="d-sm-inline-flex flex-sm-row-reverse"
              isOpen={!this.state.collapsed}
              navbar
            >
              <ul className="navbar-nav flex-grow ">
                <NavItem>
                  <NavLink
                    tag={Link}
                    className="text-body"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                    }}
                    to="/Todolist/todolist"
                  >
                    <i
                      className="fa fa-align-left"
                      style={{ fontSize: 15}}
                    ></i>
                    개인일정
                  </NavLink>
                  {/* <NavLink className="text-dark" to="/Todolist/Todolist"></NavLink> */}
                </NavItem>
                <NavItem>
                  <NavLink
                    className="text-body text-success"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                      borderBottom: 'solid 1px red',
                    }}
                    href="/home/index"
                  >
                    MES system
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    className="text-body"
                    style={{ fontSize: '13px' }}
                    to="/Map/JCMap"
                  >
                    찾는오는길
                  </NavLink>
                  {/* <NavLink  className="text-dark" to="/Map/JCMap"></NavLink> */}
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-body" style={{ fontSize: '13px' }} to="/Math">대안수학</NavLink>
                  {/* <NavLink  className="text-dark" to="/Map/JCMap"></NavLink> */}
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-body" style={{ fontSize: '13px' }} to="/WatchApi/WatchYebo">날씨예보</NavLink>
                </NavItem>
              </ul>
            </Collapse>
            <ul
              className="navbar-nav flex-grow "
              style={{ textAlign: 'right', marginLeft: '50px' }}
            >
              <WatchMenu />
            </ul>
          </Container>
        </Navbar>
      </header>
    );
  }
}
